import { assert_hash_sha256_not_empty, assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { assert_string_uuid_not_empty } from '@shared/asserts/utils_asserts_string';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__generation_consume_content extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION__CONSUME_CONTENT;

  /*
   * FIELDS
   */
  generation_id_consumer!: string;
  field_id_consumer!: string;
  hash_sha256_content!: string;

  /*
   * METHODS
   */

  constructor() {
    super();
  }

  assert_standard_fields() {
    assert_hash_sha256_not_empty(this.hash_sha256_content);
    assert_string_object_id_not_empty(this.generation_id_consumer);
    assert_string_uuid_not_empty(this.field_id_consumer);
  }
}
